import React from 'react';

import {EventReviewFeedback} from 'src/modules/ai';
import {HighlighterWrapper} from 'src/modules/event-review/highlighter/highlighter-wrapper';
import {HighlightFields} from 'src/modules/event-review/typedefs';
import {ChangeRequest} from 'src/openapi/models/ChangeRequest';
import {EventDetailInfo} from 'src/openapi/models/EventDetailInfo';

import {Group, Item} from '@pb/kit-component-group';
import {Scrollable} from '@pb/kit-component-scrollable';

import {eventReviewTrigger, eventReviewTriggerText, eventReviewTriggerWrapper} from '../../event-review.module.styl';

type Props = {
    changeRequest: ChangeRequest,
    eventCodeInfo: EventDetailInfo | null,
    highlightsInfo: Record<HighlightFields, boolean> | null,
};

export const EventTrigger = (props: Props) => {
    const {
        changeRequest,
        eventCodeInfo,
        highlightsInfo,
    } = props;

    return (
        <Group direction="v" gap="xxs" justify="space-between">
            <Group>
                <strong>Trigger:</strong>
                <EventReviewFeedback changeRequestId={changeRequest.id} fieldName={HighlightFields.trigger}/>
            </Group>
            <Item style={{width: '100%'}} className={`${eventReviewTrigger} pdy-s pdx-s`}>
                <div className={eventReviewTriggerWrapper}>
                    <Scrollable>
                        <HighlighterWrapper
                            actualValue={eventCodeInfo?.trigger || ''}
                            changeRequestValue={changeRequest.event.trigger}
                            highlight={!!highlightsInfo?.[HighlightFields.trigger]}>
                            <span className={eventReviewTriggerText}>
                                {changeRequest.event.trigger}
                            </span>
                        </HighlighterWrapper>
                    </Scrollable>
                </div>
            </Item>
        </Group>
    );
};
